const indexMaker = (index, name) => `${name}-${index}`;
export default indexMaker;